import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type TeamNameDisplayMode = 'arabic' | 'french';

interface TeamNameDisplayState {
  displayMode: TeamNameDisplayMode;
  setDisplayMode: (mode: TeamNameDisplayMode) => void;
  toggleDisplayMode: () => void;
}

const getInitialDisplayMode = (): TeamNameDisplayMode => {
  try {
    const raw = localStorage.getItem('team-name-display-preference');
    if (raw) {
      const mode = JSON.parse(raw)?.state?.displayMode;
      if (mode === 'arabic' || mode === 'french') return mode;
    }
  } catch {}
  return 'arabic';
};

export const useTeamNameDisplayStore = create<TeamNameDisplayState>()(
  persist(
    (set) => ({
      displayMode: getInitialDisplayMode(),
      setDisplayMode: (mode) => set({ displayMode: mode }),
      toggleDisplayMode: () =>
        set((state) => ({
          displayMode: state.displayMode === 'arabic' ? 'french' : 'arabic',
        })),
    }),
    {
      name: 'team-name-display-preference', // localStorage key
    }
  )
);
